import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import {
  UniversalFilterInvoicesValue,
  UniversalFilterInvoicesModes,
  UniversalFilterInvoicesFilterState,
  UniversalFilterInvoicesOnChange
} from '../../UniversalFilterInvoices.types';

interface UniversalFilterInvoicesFilterStateOptions {
  onChange: UniversalFilterInvoicesOnChange;
}

function useUniversalFilterInvoicesFilterState({
  onChange
}: UniversalFilterInvoicesFilterStateOptions) {
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterInvoicesFilterState) => void
  >(
    (filterState) => {
      const invoiceIds = filterState?.invoiceIds;

      if (filterState?.mode === UniversalFilterInvoicesModes.CONTAINS_ALL_OF) {
        onChange(isEmpty(invoiceIds) ? undefined : { in: invoiceIds });
        return;
      }

      onChange();
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterInvoicesValue
    ) => UniversalFilterInvoicesFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (!isEmpty(filterValue?.in)) {
      return {
        mode: UniversalFilterInvoicesModes.CONTAINS_ALL_OF,
        userIds: filterValue.in
      };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterInvoicesFilterState;
